import { render, staticRenderFns } from "./add-event-cover-modal.vue?vue&type=template&id=03b48e7b&scoped=true"
import script from "./add-event-cover-modal.vue?vue&type=script&lang=js"
export * from "./add-event-cover-modal.vue?vue&type=script&lang=js"
import style0 from "./add-event-cover-modal.vue?vue&type=style&index=0&id=03b48e7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b48e7b",
  null
  
)

export default component.exports